import { render } from "./AnimalSale.vue?vue&type=template&id=00b0c38d&scoped=true"
import script from "./AnimalSale.vue?vue&type=script&lang=js"
export * from "./AnimalSale.vue?vue&type=script&lang=js"

import "./AnimalSale.vue?vue&type=style&index=0&id=00b0c38d&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b0c38d"]])

export default __exports__